import { MarketAdjustmentWritable } from 'api';
import { DataEditorProps, ValueViewerProps } from 'common/types/scalarSpreadsheet';
import { SelectValueViewer } from 'components';
import { GridSelect } from 'components/FeaturedSpreadsheet/components';
import {
  FUND_INVESTMENTS_MARKET_ADJUSTMENT_SPREADSHEET_CALCULATIONS_COLUMNS,
  FUND_INVESTMENTS_MARKET_ADJUSTMENT_SPREADSHEET_COLUMNS,
} from 'pages/FundInvestments/common/constants';
import { getMarketAdjustmentSelection } from 'pages/FundInvestments/hooks/useFundInvestmentMarketAdjustmentSheet/config/createParser/utils/getMarketAdjustmentSelection';
import { normalizeHiddenCell } from 'pages/FundInvestments/hooks/useFundInvestmentMarketAdjustmentSheet/config/createParser/utils/normalizeHiddenCell';
import { getStringValue } from 'utilities';
import { HandleAdjustmentSelectionCellsParams } from './handleAdjustmentSelectionCells.types';

const {
  MEDIAN: MEDIAN_LABEL,
  SPECIFIED: SPECIFIED_LABEL,
  WEIGHTED: WEIGHTED_LABEL,
} = MarketAdjustmentWritable.adjustment_selection;

const { metric_selection_as_of_market_date: METRIC_SELECTION_AS_OF_MARKET_DATE, percentage_change: PERCENTAGE_CHANGE } =
  FUND_INVESTMENTS_MARKET_ADJUSTMENT_SPREADSHEET_COLUMNS;

const { adjustment_selection: ADJUSTMENT_SELECTION } =
  FUND_INVESTMENTS_MARKET_ADJUSTMENT_SPREADSHEET_CALCULATIONS_COLUMNS;

const handleAdjustmentSelectionCells = (params: HandleAdjustmentSelectionCellsParams): void => {
  const {
    adjustmentOptions,
    adjustmentSelection,
    cell,
    colNumber,
    isSingleComparison,
    percentileSelectionA,
    percentileSelectionB,
  } = params;

  const marketAdjustmentSelection = getMarketAdjustmentSelection({
    adjustmentSelection,
    percentileSelectionA,
    percentileSelectionB,
  });

  switch (colNumber) {
    case METRIC_SELECTION_AS_OF_MARKET_DATE.column:
      cell.className = `${cell.className} read-only--white`;
      cell.hidden = false;
      cell.value = ADJUSTMENT_SELECTION.title;
      break;

    case PERCENTAGE_CHANGE.column:
      cell.className = `${cell.className} right-aligned`;
      cell.customKey = ADJUSTMENT_SELECTION.key;
      cell.dataEditor = (props: DataEditorProps) => (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore: GridSelect is not typed
        <GridSelect enumerated menuPosition="fixed" options={adjustmentOptions} {...props} />
      );
      cell.dbType = 'string';
      cell.defaultValue = MEDIAN_LABEL;
      cell.gridType = 'string';
      cell.hidden = false;
      cell.isRequired = true;
      cell.readOnly = false;
      cell.valueViewer = (props: ValueViewerProps) => (
        <SelectValueViewer options={adjustmentOptions} useLabel {...props} />
      );

      if (isSingleComparison) {
        cell.value = getStringValue(
          marketAdjustmentSelection && ![SPECIFIED_LABEL, WEIGHTED_LABEL].includes(marketAdjustmentSelection)
            ? SPECIFIED_LABEL
            : marketAdjustmentSelection
        );
      } else {
        cell.value = getStringValue(marketAdjustmentSelection ?? MEDIAN_LABEL);
      }
      break;

    default:
      normalizeHiddenCell(cell);
      break;
  }
};

export default handleAdjustmentSelectionCells;
